import React from 'react';
import { Link, useParams } from 'react-router-dom';

function RenewEnergyBreadCrumb() {
  const { plantName} = useParams();
  
    // Convert slug (with -) back to spaces
    const dPlantName = plantName.replace(/-/g, ' ');
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title mb-2">{dPlantName}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/Admin" className="breadcrumb-link">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/renewableenergy" className="breadcrumb-link">Renewable Energy plants in India</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {dPlantName}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}
export default RenewEnergyBreadCrumb;
